import { postMethod, patchMethod, getMethod } from '../../api/methods'
import API_ROUTES from '../../api/routes'

const {
  GET_USER,
  ADD_NEW_USER,
  UPDATE_USER,
  UPDATE_USER_CONTENT,
  SEARCH_USER,
  GET_USER_PROFILE,
  ADD_ASSOCIATE,
  GET_BUILDING,
  ADD_BUILDING,
  USER_VALIDATION,
  SEND_USER_REMINDER,
  RESOLVE_USER_REMINDER,
  GET_USER_REMINDERS,
  GET_TAGS_LIST,
  DIS_ASSOCIATE,
  ALL_ADDRESS_DATA,
} = API_ROUTES

const getUserList = async ({ params }) => {
  const response = await getMethod(GET_USER({ params }))
  return response?.data
}
const getBuildingList = async ({ params }) => {
  const response = await getMethod(GET_BUILDING({ params }))
  return response?.data
}
const addNewUserApi = async ({ payload }) => {
  const response = await postMethod(ADD_NEW_USER, payload)
  return response
}
const addNewBuildingApi = async ({ payload }) => {
  const response = await postMethod(ADD_BUILDING, payload)
  return response
}
const updateBuildingApi = async ({ payload }) => {
  const response = await patchMethod(ADD_BUILDING, payload)
  return response
}
const updateUserApi = async ({ payload }) => {
  const response = await patchMethod(UPDATE_USER, payload)
  return response
}
const updateUserContentApi = async ({ payload }) => {
  const response = await patchMethod(UPDATE_USER_CONTENT, payload)
  return response
}
const getUserProfileApi = async ({ id }) => {
  const response = await getMethod(GET_USER_PROFILE(id))
  return response
}

const searchUserApi = async ({ params }) => {
  const response = await getMethod(SEARCH_USER({ params }))
  return response?.data
}

const addAssociateApi = async ({ payload, params }) => {
  const response = await postMethod(ADD_ASSOCIATE({ params }), payload)
  return response?.data
}

const disAssociateApi = async ({ payload, params }) => {
  const response = await postMethod(DIS_ASSOCIATE({ params }), payload)
  return response?.data
}

const userValidationApi = async ({ params }) => {
  const response = await getMethod(USER_VALIDATION({ params }), {
    hideErrorPopup: true,
  })
  return response?.data
}

const sendUserReminderApi = async ({ payload }) => {
  const response = await postMethod(SEND_USER_REMINDER, payload)
  return response
}

const resolveUserReminderApi = async ({ id }) => {
  const response = await patchMethod(RESOLVE_USER_REMINDER({ id }))
  return response
}

const getUserRemindersApi = async ({ pageNo, userId }) => {
  const response = await getMethod(GET_USER_REMINDERS({ pageNo, userId }))
  return response?.data
}

const getTagListApi = async ({ params }) => {
  const response = await getMethod(GET_TAGS_LIST, { params })
  return response?.data
}

const getAddressDataListApi = async ({ params }) => {
  const response = await getMethod(ALL_ADDRESS_DATA({ params }))
  return response?.data
}

export {
  getUserList,
  addNewUserApi,
  updateUserApi,
  updateUserContentApi,
  getUserProfileApi,
  searchUserApi,
  addAssociateApi,
  getBuildingList,
  addNewBuildingApi,
  updateBuildingApi,
  userValidationApi,
  sendUserReminderApi,
  resolveUserReminderApi,
  getUserRemindersApi,
  getTagListApi,
  disAssociateApi,
  getAddressDataListApi,
}
